import { Component, OnInit, NgZone } from '@angular/core';
declare var $: any;
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { AnpiService } from '../../../_services/anpi-code.service';
import { first } from 'rxjs/operators';
import { ConfirmPasswordValidator } from '../../../_validators/confirm-password.validator';
import { AuthenticationService } from '../../../_services/authentication.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { data } from 'jquery';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  passwordFieldType: string = "password";
  showPassword = false;
  employee = false;
  public bankDetailsForm: FormGroup;
  public mobileMoneyForm: FormGroup;
  public resetPasswordForm: FormGroup;
  bankDetails = false;
  response: any;
  isSubmitted = false;
  profileDetails: any;
  bankdata: any;
  bank = false;
  login: any;
  accountDetails: any;
  currentLang: string;
  responseupload: any;
  bank_slip: any;
  buinessList: boolean;
  profilesec = true;
  bankDatalist: any;
  bank_ac_statement_url: any;
  bank_section = true;
  openBankdetails = false;
  selected_bank_id: any;
  showBankDetails: boolean = false;
  deleteResponse: any;
  responseupdateDp: any;
  currentUser: any;


  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private anpiService: AnpiService,
    private ngzone: NgZone,
    private authenticationService: AuthenticationService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      this.login = this.accountDetails.current_user;
      if (this.login == "1") {
        this.employee = false;
      } else {
        this.employee = true;
      }
    }
    if (this.router.getCurrentNavigation().extras.state) {
      const data = this.router.getCurrentNavigation().extras.state.profile_section
      console.log("73", data)
      if (data) {
        this.open(data);
      }
    }
  }

  ngOnInit() {
    console.log("36", this.isSubmitted)
    AOS.init({
      disable: function() {
        // var maxWidth = 600;
        // return window.innerWidth < maxWidth;
      }
    });
    this.resetPasswordForm = this.formBuilder.group({
      current_password: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).{7,}$")]],
      confirmPassword: ['', [Validators.required]],
    }, { validator: ConfirmPasswordValidator.MatchPassword });

    this.bankDetailsForm = this.formBuilder.group({
      banks: ['1', [Validators.required]],
      // account_number: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      // account_name: [''], bank_name: [''], bank_number: [''], bank_counter: [''],
      account_number: [''],
      account_name: [''],
      bank_name: [''],
      bank_number: [''],
      bank_counter: [''],
      bank_slip: ['', [Validators.required]],
      imageFile: ['']
    });

    this.getBanks();
    this.currentLang = localStorage.getItem('language') || "fr";
  }
  closeModal() {
    this.isSubmitted = false;
    $('#signinModal').modal('hide');
    this.resetPasswordForm.reset();
  }
  onSubmitBankForm() {
    this.isSubmitted = true;
    if (this.bankDetailsForm.invalid) {
      console.log("196", this.bankDetailsForm)
      return;
    }
    var data = {
      account_no: this.g.account_number.value,
      account_name: this.g.account_name.value,
      bank_name: this.g.bank_name.value,
      bank_no: this.g.bank_number.value,
      bank_counter: this.g.bank_counter.value,
      bank_id: this.g.banks.value,
      bank_slip: this.g.bank_slip.value
    }
    console.log("145", data)
    this.ngxUiLoaderService.start();
    this.api.bankDetails(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {

            this.bankDetailsForm.reset();
            this.isSubmitted = false;
            $('#bankAccountModal').modal('hide');
            this.anpiService.emitEvent();
            this.bankDetailsForm.controls['bank_name'].setValue(this.bankdata[0].bank_name);
            this.bankDetailsForm.controls['banks'].setValue('1');
            this.bankDetails = true;
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
            this.showBankDetails = false;
            this.openBankdetails = false
            this.getbankList();
            this.anpiService.emitEvent();
            this.anpiService.emitAccountEvent();
          } else {
            this.isSubmitted = false;
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.isSubmitted = false;
          this.ngxUiLoaderService.stop();
        });

  }
  onSubmitResetPassword() {
    this.isSubmitted = true;
    console.log("160")
    if (this.resetPasswordForm.invalid) {
      console.log("196", this.resetPasswordForm)
      return;
    }
    var data = this.resetPasswordForm.value;
    this.ngxUiLoaderService.start();
    this.api.changePassword(data).pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res;
          if (this.response.status == 200) {
            $('#signinModal').modal('hide');
            this.resetPasswordForm.reset();
            this.snackBar.open(this.response.message, "OK", {
              duration: 5000,
            });
          } else {
            this.snackBar.open(this.response.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
    this.isSubmitted = false;
  }
  logout() {
    this.ngxUiLoaderService.start();
    this.authenticationService.logout();
    localStorage.removeItem('business');
    localStorage.removeItem('bank');
    localStorage.removeItem('employees');
    localStorage.removeItem('cnssForm');
    localStorage.removeItem('cnamgsForm');
    localStorage.removeItem('account_status');
    localStorage.removeItem('login');
    this.ngxUiLoaderService.stop();
    this.router.navigate(['/']);
  }
  showSearch() {
    console.log('333')
    $('#searchStyle').addClass('searchTransform');
    $('#searchInput').addClass('changeSearchStyle');
    $('small').css({ display: "none" });

  }

  open(val) {
    console.log(val)
    switch (val) {
      case 'sidenav1':
        {
          this.bankDetailsForm.reset();
          this.bankDetails = false;
          this.profilesec = true;
          this.buinessList = false;
          console.log('196')
          break;
        }
      case 'sidenav3':
        {
          this.getbankList()
          setTimeout(() => {
            console.log($('#bank1'))
            $('#bank1').prop('checked', true);
            // this.bank = true
            // this.g['bank_number'].setValidators([Validators.required]);
            // this.g['bank_number'].updateValueAndValidity()
            // this.g['bank_slip'].updateValueAndValidity();
          }, 1000)

          this.bankDetails = true;
          this.profilesec = true;
          this.buinessList = false;
          console.log('202')
          break;
        }
      case 'sidenav4':
        {
          this.bank = false;
          this.bankDetails = false;
          this.buinessList = true;
          this.profilesec = false;
          console.log(this.bankDetails)
          break;
        }
    }
  }

  eyeclose() {
    $('#eye').toggleClass('fa-eye fa-eye-slash');
    this.showPassword = (this.showPassword) ? false : true;
    if (this.showPassword) {
      this.passwordFieldType = "text";
    } else {
      this.passwordFieldType = "password";
    }
  }
  getCnssPdf() {
    this.ngxUiLoaderService.start();
    this.api.getCnssPdf().pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          console.log("263", data)
          if (data.status == 200) {
            window.open(data.imagePath, '_blank');
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
    // window.open('/assets/pdf/CNSS_FORM.pdf', '_blank');
  }

  getCnamgsPdf() {
    this.ngxUiLoaderService.start();
    this.api.getcnamgsPdf().pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          console.log("263", data)
          if (data.status == 200) {
            window.open(data.imagePath, '_blank');
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
    // window.open('/assets/pdf/CNSS_FORM.pdf', '_blank');
  }


  getBanks() {
    console.log("260")
    this.ngxUiLoaderService.start();
    this.api.getBankList().pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          console.log("263", data)
          this.response = data.Results;
          if (data.status == 200) {
            this.bankdata = data.Results;
            console.log("bankdata", this.bankdata);

            setTimeout(() => {
              this.ngzone.run(() => {
                console.log($('#bank1'))
                // this.bank = true
                // this.g['bank_number'].setValidators([Validators.required]);
                // this.g['bank_number'].updateValueAndValidity();
                // this.g['bank_slip'].updateValueAndValidity();
                this.bankDetailsForm.controls['bank_name'].setValue(this.bankdata[0].bank_name);
              });
            }, 2000)
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  handleChange(e, value, banks, type) {
    console.log("284", value)
    this.bank_slip = null;
    // this.bankDetailsForm.controls['account_number'].reset();
    // this.bankDetailsForm.controls['bank_number'].reset();
    // this.bankDetailsForm.controls['bank_counter'].reset();
    this.bankDetailsForm.controls['bank_name'].setValue(value);
    this.bankDetailsForm.controls['banks'].setValue(banks);
    this.isSubmitted = false;
    // Bank-type-based form field logic removed: show bank slip only for every bank
    // if (type == 1) {
    //   this.bank = true;
    //   this.g['account_number'].setValidators([Validators.required, Validators.pattern("^[0-9]{11}$")]);
    //   this.g['account_number'].updateValueAndValidity();
    //   this.g['bank_number'].setValidators([Validators.required, Validators.pattern("^[0-9]*$")]);
    //   this.g['bank_number'].updateValueAndValidity();
    //   this.g['bank_slip'].updateValueAndValidity();
    // } else {
    //   this.bank = false
    //   this.g['account_number'].setValidators([
    //     Validators.required,
    //     Validators.pattern("^(77|76|74|66|65|62|60|61)[0-9]{6}$")
    //   ]);
    //   this.g['account_number'].updateValueAndValidity();
    //   this.g['bank_number'].clearValidators();
    //   this.g['bank_number'].setValue(null);
    //   this.g['bank_number'].updateValueAndValidity();
    //   this.g['bank_slip'].clearValidators();
    //   this.g['bank_slip'].setValue(null);
    //   this.g['bank_slip'].updateValueAndValidity();
    // }

  }
  upload(event: any, id): void {
    console.log("2250", event);
    console.log("2251", event.target.files[0]);
    const fileNameDisplay = document.getElementById(id);

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('uploaded image: ', file);
      const filename = file.name;
      var ext = filename.split('.').pop();

      if (file.size > 5242880) {
        if (this.currentLang == 'fr') {
          alert('La taille du fichier doit être inférieure à 5MB');
        } else {
          alert('File Size should be less than 5MB');
        }
        return;
      }

      if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'pdf' && ext != 'PDF' && ext != 'doc' && ext != "Doc" && ext != 'docx' && ext != "DOCX" && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'heif' && ext != 'tiff' && ext != 'TIFF') {
        if (this.currentLang == 'fr') {
          alert('Type de fichier non autorisé. Les types de fichier autorisés sont  .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
        } else {
          alert('File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
        }
        return;
      }

      this.ngxUiLoaderService.start();
      const target = event.target.dataset.target;
      console.log(target);
      const formData = new FormData();
      formData.append('image', file);
      formData.append('target', target);
      formData['encrypt_mode'] = false;
      this.api.bankUpload(formData).pipe(first())
        .subscribe(data => {
            this.responseupload = data;
            if (this.responseupload.status == 200) {
              this.ngxUiLoaderService.stop();
              // if (this.currentLang == 'fr') {
              //   fileNameDisplay.textContent = `Cliquez pour voir le fichier`;
              // } else {
              //   fileNameDisplay.textContent = `Click to view File`;
              // }
              this.bank_slip = this.responseupload.results.imageUrl;
              this.bankDetailsForm.controls['bank_slip'].setValue(this.responseupload.results.file);
              console.log(this.bankDetailsForm.controls);
              this.snackBar.open(this.responseupload.message, "OK", {
                duration: 5000,
              });

            } else {
              this.snackBar.open(this.responseupload.message, "OK", {
                duration: 5000,
              });
            }
          },
          error => {
            // Handle error
          });
    }
  }


  get f() {
    return this.resetPasswordForm.controls;
  }
  get g() {
    return this.bankDetailsForm.controls;
  }


  getBusiness() {
    return localStorage.getItem('business');
  }
  getCnssForm() {
    return localStorage.getItem('cnssForm');
  }

  setBankAccountName() {
    this.bankDetailsForm.controls['account_name'].setValue(this.accountDetails.company_name);
    this.bankDetailsForm.controls['account_name'].updateValueAndValidity();

  }

  getbankList() {
    this.ngxUiLoaderService.start();
    this.api.getBankLists().subscribe(data => {
      this.response = data;
      console.log(this.response);

      if (this.response.status == 200) {
        this.ngxUiLoaderService.stop();

        this.bankDatalist = this.response.results;

        console.log(this.bankDatalist, '111111111111111111111111');

      } else {
        this.snackBar.open(this.bankDatalist.message, "OK", {
          duration: 5000,
        });
      }
    }, error => {

    });
  }

  showBankdetails() {
    this.showBankDetails = !this.showBankDetails;
    this.openBankdetails = !this.openBankdetails;
    this.bankDetailsForm.reset();
    this.isSubmitted = false;
    this.bank = true;
    this.bankDetailsForm.controls['bank_name'].setValue(this.bankdata[0].bank_name);
    this.bankDetailsForm.controls['banks'].setValue('1');

    console.log('ippo sheriyaakki tharam....!');
  }
  goBackbutton() {
    this.showBankDetails = false;
    this.openBankdetails = false
  }
  selectedBank(id) {
    this.selected_bank_id = id;
    console.log("485", this.selected_bank_id)
    $('#permissionRejectModal').modal('show');
  }
  deleteBank() {
    if (this.selected_bank_id) {
      this.ngxUiLoaderService.start();
      var data = {
        bank_id: this.selected_bank_id
      }
      this.api.deleteBankList(data).subscribe(data => {
        this.deleteResponse = data;
        this.ngxUiLoaderService.stop();
        if (this.deleteResponse.status == 200) {
          this.getbankList()
          $('#permissionRejectModal').modal('hide')
          this.anpiService.emitEvent();
          this.anpiService.emitAccountEvent();
        } else {
          this.snackBar.open(this.deleteResponse.message, "OK", {
            duration: 5000,
          });
        }

      })
    } else {
      return;
    }

  }

  getAccountData() {
    console.log("442 get employer details")
    this.ngxUiLoaderService.start();
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res.results;
          if (res.status == 200) {
            console.log("88", res)
            this.accountDetails = this.response;
            if (this.response.current_user == 1) {
              this.currentUser = this.response.current_user;
              console.log("450", this.currentUser)
            } else if (this.response.employee.current_user == 2) {
              this.currentUser = this.response.employee.current_user;
            }
            this.login = this.currentUser;
            console.log("92", this.login)
            if (this.currentUser == 2) {
              const data = JSON.stringify(this.accountDetails.employee);
              localStorage.setItem('currentUserDetails', data);
              console.log("117", data)
              const setdata = localStorage.getItem('currentUserDetails');
              if (setdata) {
                this.accountDetails = JSON.parse(setdata);
                this.login = this.accountDetails.current_user;
                if (this.login == "1") {
                  this.employee = false;
                } else {
                  this.employee = true;
                }
              }
            }
            this.anpiService.emitEvent();
          } else {
            console.log("no result")
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          console.log("errorrrrrrrrr")
          this.ngxUiLoaderService.stop();
        });
    console.log("no result")
  }

  uploadDp(event: any, target: string): void {
    console.log("2222", event.target.files[0])
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('uploaded image: ', file)
      const filename = file.name;
      console.log("aaaaaaaaaaa", filename);
      var ext = filename.split('.').pop();
      if (file.size > 5242880) {

        if (this.currentLang == 'fr') {
          alert('La taille du fichier doit être inférieure à 5MB')
        } else {
          alert('File Size should be less than 5MB')
        }
        return;
      }
      if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg') {
        if (this.currentLang == 'fr') {
          alert('Type de fichier non autorisé. Les types de fichier autorisés sont  .jpg .png .jpeg')
        } else {
          alert('File type not allowed. Allowed file types are .jpg .png .jpeg')
        }
        return;
      }
      this.ngxUiLoaderService.start();
      const target = event.target.dataset.target;
      console.log("target", target)
      const formData = new FormData();
      console.log("formDataaaaaaa", formData);
      formData.append('image', file);
      formData.append('target', target);
      console.log("file is :", file)
      console.log("target is :", target)
      formData['encrypt_mode'] = false;
      this.api.updateDp(formData).pipe(first()).subscribe(res => {
        this.ngxUiLoaderService.stop();
        console.log("updatedDpData", res);
        this.responseupdateDp = res;
        if (this.responseupdateDp.status == 200) {
          this.snackBar.open(this.responseupdateDp.message, "OK", {
            duration: 2000,
          });
          this.getAccountData()
        } else {
          this.snackBar.open(this.responseupdateDp.message, "OK", {
            duration: 2000,
          });
        }
      })
    }

  }
}
